<template>
    <div>
        <el-row>
            <el-col>
                <el-card shadow="never">
                    <h1 style="text-align:left;margin-top:unset;">Export Status Order</h1>
                    <el-row :sm="24">
                        <el-col class="text-md-left">
                            <el-form label-position="top" label-width="100px" @submit.native.prevent="() => {}">
                                <el-form-item label="เลือกวันที่ต้องการ">
                                    <el-date-picker
                                        v-model="datePick"
                                        type="daterange"
                                        range-separator="To"
                                        start-placeholder="Start date"
                                        end-placeholder="End date">
                                    </el-date-picker>
                                    <el-button type="primary" style="margin-left:10px;" @click="processExcel('full')">Full Export Order </el-button>
                                    <el-button type="primary" style="margin-left:10px;" @click="processExcel('short')">Short Export Order</el-button>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import mixinExcel from '@/mixins/exportExcel.js'
import fgApi from '@/services/fillgoods'

export default {
    name: 'ExportStatusOrder',
    mixins: [mixinExcel],
    data () {
        return {
            datePick: null,
            offset: 0,
            rowCheck: 1,
            fetchExcel: false,
            excelHead: [],
            checkData: false
        }
    },
    created () {
        let dateTo = new Date()
        let dateFrom = new Date()
        dateFrom.setDate(dateTo.getDate() - 14)
        this.datePick = [dateFrom, dateTo]
    },
    methods: {
        async processExcel (val) {
            this.$loading({
                text: 'กำลังโหลดข้อมูล...'
            })
            if (val === 'full') {
                this.excelHead = this.excelScgStatusHeaderFull
                this.fetchScgStatus(val)
            } else if (val === 'short') {
                this.excelHead = this.excelScgStatusHeaderSub
                this.fetchScgStatus(val)
            }
        },
        async fetchScgStatus (val) {
            if (this.fetchExcel) {
                this.excelHead = []
                this.checkData = false
                this.fetchExcel = false
                this.offset = 0
                return
            }
            let dateFrom = this.datePick[0].getFullYear() + '-' + String(this.datePick[0].getMonth() + 1).padStart(2, '0') + '-' + String(this.datePick[0].getDate()).padStart(2, '0') + ' 00:00:00'
            let dateTo = this.datePick[1].getFullYear() + '-' + String(this.datePick[1].getMonth() + 1).padStart(2, '0') + '-' + String(this.datePick[1].getDate()).padStart(2, '0') + ' 23:59:59'
            let param = {
                from: dateFrom,
                to: dateTo,
                limit: 1000,
                offset: this.offset
            }
            this.offset = (this.offset + 1000) + 1

            try {
                let res = {}
                if (val === 'full') {
                    res = await fgApi.order.getScgStatusExcelFull(param)
                } else if (val === 'short') {
                    res = await fgApi.order.getScgStatusExcelShort(param)
                }
                console.log(res)
                if (res.data.length > 0) {
                    this.checkData = true
                    if (val === 'full') {
                        res.data.forEach((order) => {
                            let arrData = [
                                this.$dayjs(order.createdAt).format('YYYY-MM-DD HH:mm:ss'), order.shopName, order.orderNumber, order.trackingNumber, order.customerName, order.phoneNumber,
                                this.getPaymentType(order.paymentType), order.zipcode, `${this.getOrderStatus(order.orderStatus)} (${this.getOrderStatusEn(order.orderStatus)})`,
                                this.$dayjs(order.statusDate).format('YYYY-MM-DD HH:mm:ss'), order.scgOrderStatus
                            ]
                            this.excelHead.push(arrData)
                        })
                    } else if (val === 'short') {
                        console.log(res)
                        res.data.forEach((order) => {
                            let orderStatus = order.orderStatus.map(e => { return `${this.getOrderStatus(e)} (${this.getOrderStatusEn(e)})` })
                            let arrData = [
                                this.$dayjs(order.createdAt).format('YYYY-MM-DD HH:mm:ss'), order.shopName, order.orderNumber, order.trackingNumber, order.customerName, order.phoneNumber,
                                this.getPaymentType(order.paymentType), order.zipcode, orderStatus.join(', '),
                                order.statusDate.join(', '), order.startDate, order.lastStartDate, `${this.getOrderStatus(order.lastStatus)} (${this.getOrderStatusEn(order.lastStatus)})`,
                                order.scgLastStatus, order.scgOrderStatus.join(', ')
                            ]
                            this.excelHead.push(arrData)
                        })
                    }
                } else {
                    if (this.checkData) {
                        this.fetchExcel = true
                        this.saveExcelmet(val)
                        this.fetchScgStatus(val)
                        return
                    }
                    this.fetchExcel = true
                    this.$message({
                        message: 'ไม่พบข้อมูล',
                        type: 'warning'
                    })
                    this.$loading().close()
                }
            } catch (error) {
                this.fetchExcel = true
                this.$notify.error({
                    title: 'Error',
                    message: 'Network Error'
                })
                console.log(error)
                this.$loading().close()
            }
            this.fetchScgStatus(val)
        },
        saveExcelmet (val) {
            this.saveExcel(this.excelHead, `${val}_status_scg_orders`)
            console.log(this.excelHead)
            this.$loading().close()
        }

    }
}
</script>

<style lang="scss" scoped>

</style>
